$(document).on('turbolinks:load', function(){
  $('#players-extra-points').DataTable({
    info: false,
    bPaginate: false,
    ajax: {
      url: '/leagues/' + gon.league_id + '/players?round_type_id=' + gon.round_type_id,
    },
    ext: {
      pager: {
        numbers_length: 2
      },
    },
    columns: [
      {
        data: 'division_name',
      },
      {
        data: 'formal_name',
      },
      {
        data: function(data) {
          var extraPoints = gon.player_extra_points;
          var elem = extraPoints.find(elem => elem.id == data.id);
          return Mustache.render(
            $('#mustache_input').html(),
            {
              competitor: data.id,
              extraPoints: elem?.points || data.extra_points,
              competitorType: 'Player',
              roundTypeId: gon.round_type_id
            }
          );
        },
        className: 'text-center w-10'
      },
    ]
  });
});